import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ContextIdDto, DatalistService, CreateDataList, DataListDto, UpdateDataList, DataItemDto } from '@savvy/datalist';
import { FloSnackbarComponent } from '../snackbar/floSnackbar.component';

@Component({
  selector: 'app-add-edit-datalist',
  templateUrl: 'addEditDatalist.html',
  styleUrls: ['addEditDatalist.scss'],

})
export class AddEditDatalistComponent implements OnInit {

  model = {} as DataListDto;
  newItemName: string;
  private sub: any;
  private contextIdDto: ContextIdDto;

  constructor(
    private route: ActivatedRoute,
    private api: DatalistService,
    private notify: FloSnackbarComponent
  ) { }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.contextIdDto = {} as ContextIdDto;
      this.contextIdDto.contextId = params['contextId'];
      this.contextIdDto.contextIdType = params['contextIdType'];
      console.log('dataListId is ' + params['dataListId']);
      console.log('contextId is ' + params['contextId']);

      if (params['dataListId']) {
        this.api.loadDataList(this.contextIdDto.contextId,
          this.contextIdDto.contextIdType,
          params['dataListId']).subscribe(response => {
            this.model = response;
          });
      }
    });
  }

  addList() {
    console.log('creating');
    const req = {} as CreateDataList;
    req.contextIdDto = this.contextIdDto;
    req.dataListDto = this.model;
    this.api.createDataList(req).subscribe(response => {
      // Stay on page? and change it to edit screen?
      this.model = response;
      console.log('created new list');
    });
  }

  addItem() {
    const newItem = {} as DataItemDto;
    newItem.name = this.newItemName;
    newItem.label = this.newItemName;
    console.log('adding  ' + this.newItemName);
    if (!this.model.dataItems) {
      this.model.dataItems = [];
    }
    this.model.dataItems.push(newItem);
    this.updateList();
  }

  deleteItem(item: DataItemDto) {
    console.log('removing  ' + this.newItemName);
    const index = this.model.dataItems.indexOf(item);
    if (index > -1) {
      this.model.dataItems.splice(index, 1);
    }
    this.updateList();
  }

  updateList() {
    const req = {} as UpdateDataList;
    req.contextIdDto = this.contextIdDto;
    req.dataListDto = this.model;
    this.api.updateDataList(req).subscribe(response => {
      this.model = response;
      console.log('updated list');
      this.notify.message = 'Updated list';
      this.notify.open();
    });
  }

  drop(event: CdkDragDrop<DataItemDto[]>) {
    moveItemInArray(this.model.dataItems, event.previousIndex, event.currentIndex);
    this.updateList();
  }
}


/*
 Copyright 2016 Google Inc. All Rights Reserved.
 Use of this source code is governed by an MIT-style license that
 can be found in the LICENSE file at http://angular.io/license
 */
